import { useState } from "react";
import { container } from "tsyringe";
import Button, { EButtonVariant } from "components/elements/Button";
import Typography, { ITypo } from "components/elements/Typography";
import I18n from "components/materials/I18n";
import CorporationService from "services/CorporationService";
import classes from "./classes.module.scss";
import { ValidationError } from "common/resources/Resource";
import CorporationSheetAdminCreateMinimalRequestResource from "common/resources/CorporationSheet/CorporationSheetAdminCreateMinimalRequestResource";
import InputElement, { EInputType } from "components/materials/Form/InputElement";
import Form from "components/materials/Form";

interface ICreateMinimalClientPMProps {
	creatorId: string;
	onCorporationCreated: (corporationSheetId: string) => void;
	onCancel: () => void;
}

const corporationService = container.resolve(CorporationService);

export default function CreateMinimalClientPM({ creatorId, onCorporationCreated, onCancel }: ICreateMinimalClientPMProps) {
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<ValidationError[]>([]);

	const handleSubmit = async (_e: React.FormEvent<HTMLFormElement>, formData: { [key: string]: unknown }) => {
		setErrors([]);
		setLoading(true);

		try {
			const resource = CorporationSheetAdminCreateMinimalRequestResource.hydrate<CorporationSheetAdminCreateMinimalRequestResource>({
				raisonSociale: formData["raisonSociale"] as string,
			});
			await resource.validateOrReject();

			const corporationSheet = await corporationService.createMinimalByAdmin(resource, creatorId);
			onCorporationCreated(corporationSheet.id);
		} catch (err) {
			if (err instanceof Array) {
				setErrors(err);
			} else {
				setErrors([{ property: "form", constraints: { error: "La fiche n’a pas pu être créée. Votre saisie est conservée. Réessayez ou contactez le support." } }]);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={classes["container"]}>
			<Typography typo={ITypo.H2} className={classes["title"]}>
				{I18n.asset.pages.mo_manual_subscription.create_minimal_client_pm_title}
			</Typography>

			<Typography typo={ITypo.P_MEDIUM_BOLD} className={classes["description"]}>
				{I18n.asset.pages.mo_manual_subscription.create_minimal_client_pm_description}
			</Typography>

			<Form onSubmit={handleSubmit} className={classes["form"]} errors={errors}>
				<InputElement label="Raison sociale *" placeholder="Nom de la société" name="raisonSociale" type={EInputType.TEXT} />

				<div className={classes["actions"]}>
					<Button variant={EButtonVariant.OUTLINED} onClick={onCancel} disabled={loading}>
						Annuler
					</Button>
					<Button variant={EButtonVariant.CONTAINED} type="submit" disabled={loading}>
						{loading ? "Création..." : "Créer la société"}
					</Button>
				</div>
			</Form>
		</div>
	);
}
